
function toggleSummaryBullets() {
    var bullets = document.querySelector('.ProductMeta__SummaryBullets'),
        button = document.querySelector('.ProductMeta__ReadMore');

    if (bullets.querySelectorAll('li').length > 3) {
        var moreText = button.innerText,
            lessText = button.dataset.lessText;

        button.addEventListener('click', function() {
            this.setAttribute('aria-expanded', this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true' );
            this.innerText = this.getAttribute('aria-expanded') === 'true' ? lessText : moreText;
            bullets.classList.toggle('ProductMeta__SummaryBullets--all');
        });
    } else {
        button.style.display = 'none';
    }
}

function toggleVariantThumbnails() {
    document.addEventListener('variant:changed', function(event) {
        var variant = event.detail.variant,
            colorOption = document.querySelector('.Product').dataset.colorOption;
            
        if (colorOption in variant) {
            var colorName = variant[colorOption].replace(/\s+/g, '-').toLowerCase(),
                thumbs = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage'),
                hasThumb = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage[data-color="'+ colorName +'"]').length,
                dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');

            if (hasThumb) {
                thumbs.forEach( function(thumb) {
                    if (colorName === thumb.dataset.color.toLowerCase()) {
                        thumb.classList.remove('hidden-tablet-and-up');
                    } else {
                        thumb.classList.add('hidden-tablet-and-up');
                    }
                });
                toggleVariantDots(colorName);
            } else {
                thumbs.forEach( function(thumb) {
                    thumb.classList.remove('hidden-tablet-and-up');
                });
                dots.forEach( function(dot) {
                    dot.classList.remove('hidden-phone','hidden-tablet', 'hidden-lap');
                })
            }
        }
        
    });
}

function toggleVariantDots(selectedColor) {
    const productSlideshow = Flickity.data('.Product__Slideshow');
    if (productSlideshow) {
        var thumbs = document.querySelectorAll('.Product__SlideshowNavImage');
        var dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');
        thumbs.forEach( function(thumb,i) {
            dots[i].dataset.color = thumb.dataset.color;
            if(selectedColor === thumb.dataset.color) {
                dots[i].classList.remove('hidden-phone','hidden-tablet', 'hidden-lap');
            } else {
                dots[i].classList.add('hidden-phone','hidden-tablet', 'hidden-lap');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    toggleSummaryBullets();
    toggleVariantThumbnails();
});